<template lang="pug">
nav(:class="`nav--${nav.length}`")
  div
    div
      NavigationItem(v-for="(item, i) in nav", :item="item", :index="i", ref="items" :active="isActive(item.id)" :completed="isCompleted(i)")
</template>

<script>
import { mapGetters } from "vuex";
import NavigationItem from "./NavigationItem.vue";

export default {
  name: "Navigation",
  components: {
    NavigationItem,
  },
  props: {
    nav: Array,
  },
  data() {
    return {
      resizing: false,
      backdoorTimeout: null,
      backdoor: 0
    }
  },
  computed: {
    ...mapGetters(["formCompletionIndex"]),
    isActive() {
      return (id) => id === this.$route.params.slug;
    },
    isCompleted() {
      return (i) => this.formCompletionIndex > i
    },
    height() {
      if (this.resizing || window.innerWidth < 768) return 'auto';
      return `${this.$refs.items.reduce((max, item) => {
        if (item.$el.offsetHeight > max) max = item.$el.offsetHeight;
        return max;
      }, 0)}px`
    },
    fillDistance() {
      return this.$refs.items.reduce((distance, item, i, arr) => {
        if (item.active) {
          if (item === arr.at(-1)) distance = 0;
          else {
            const rect = item.$el.getBoundingClientRect();
            distance = `calc(100vw - ${rect.left + (rect.width / 2)}px)`;
          }
        }
        return distance;
      }, 0);
    }
  },
  methods: {
    useBackdoor() {
      clearTimeout(this.backdoorTimeout);
      this.resizing = true;
      this.backdoorTimeout = setTimeout(() => {
        this.backdoor++;
        this.resizing = false;
      }, 150)
    }
  },
  mounted() {
    window.addEventListener('resize', this.useBackdoor)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.useBackdoor)
  },
};
</script>

<style scoped lang="scss">
nav {
  --counter-height: 30px;
  --default: #adb4b9;
  --active: #ab2622;
  --tray: #f5f5f5;
  padding: 0;
  margin: 0;
  z-index: 1;
  position: relative;
  width: 100%;
  height: v-bind(height);

  @include mq(md) {
    --counter-height: 50px;
    --tray: transparent;
  }

  &::before,
  &::after {
    content: '';
    z-index: -1;
    position: absolute;
    width: 100vw;
    top: calc((var(--counter-height) / 2) - 1.5px);
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    padding-right: v-bind(fillDistance);
    background-image: linear-gradient(to bottom, var(--active) 0, var(--active) 3px, transparent 3px, transparent 100%);
    background-clip: content-box;
    transition: padding-right 0.35s ease;
    pointer-events: none;
  }

  &::before {
    background-image: linear-gradient(to bottom, var(--default) 0, var(--default) 3px, var(--tray) 3px, var(--tray) 100%);
    transition: none;
    padding-right: 0;
  }

  &>div {
    box-sizing: content-box;
    height: 100%;
    width: 100%;
    overflow: hidden;

    &>div {
      box-sizing: content-box;
      display: flex;
      gap: 1rem;
      overflow: auto;
      width: 100%;
      height: 100%;
      padding-bottom: 1.5rem;
    }
  }
}
</style>
